import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { SAVE_TO_PARENT_KEY } from '../../../../utils/postingUtils';

import { ModularListingContext } from '../../../../containers/CreateListingPage/context';

import { roommatesOptionsArray } from '../../../../constants/ListingDetailsConstants';

import actions from '../../../../containers/CreateListingPage/actions';

import DropdownFormField from '../../FormFields/DropdownFormField';

import { WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

const propTypes = {};

const defaultProps = {};

const TotalRoommateCountFormSectionContainer = () => {
  const { reducerDispatch } = useContext(ModularListingContext);

  const { roomForRent: { currentRoommatesDetails: { roommateTotalCount = null } } = {} } = useSelector(
    (state) => state.properties.currentProperty,
  );

  useEffect(() => {
    setSaveOutsideComponent(false);
  }, []);

  const setSaveOutsideComponent = (saveOutsideComponent = true) => {
    actions.updateAnyProperty({
      reducerDispatch,
      data: {
        saveOutsideComponent,
      },
    });
  };

  return (
    <WizardFormSectionContainer data-test="TotalRoommateCountFormSectionContainer">
      <WizardHeading level={1} textStyle="heading-sm">
        How many roommates will the renter have?
      </WizardHeading>

      <DropdownFormField
        inputName="roommateTotalCount"
        initialValue={roommateTotalCount}
        saveToParentKey={SAVE_TO_PARENT_KEY.ROOM_FOR_RENT}
        label=""
        optionsList={roommatesOptionsArray}
      />
    </WizardFormSectionContainer>
  );
};

TotalRoommateCountFormSectionContainer.propTypes = propTypes;
TotalRoommateCountFormSectionContainer.defaultProps = defaultProps;

export default TotalRoommateCountFormSectionContainer;
